import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ColumnSortedEvent } from 'app/core/models/column-sorted-model';
import * as moment from 'moment';

@Injectable()
export class SortService {
    private columnSortedSource = new Subject<ColumnSortedEvent>();

    columnSorted$ = this.columnSortedSource.asObservable();
    constructor() { }

    columnSorted(event: ColumnSortedEvent) {
        this.columnSortedSource.next(event);
    }

    filterAndSortlist<T>(array: T[], filterText: string, lastSort: ColumnSortedEvent): T[] {
        let filteredList = array.filter(x => {
            return Object.keys(x).find(y => x[y] && x[y].toString().toLowerCase().includes(filterText.toLowerCase())) !== undefined;
        });
        if (lastSort) {
            return filteredList.sort((x, y) => {
                let lhsValue =
                    x[lastSort.sortColumn] && !isNaN(Number(x[lastSort.sortColumn])) ?
                        Number(x[lastSort.sortColumn]) : !x[lastSort.sortColumn] ? x[lastSort.sortColumn] : x[lastSort.sortColumn].toString().trim();
                let rhsValue =
                    y[lastSort.sortColumn] && !isNaN(Number(y[lastSort.sortColumn])) ?
                        Number(y[lastSort.sortColumn]) : !y[lastSort.sortColumn] ? y[lastSort.sortColumn] : y[lastSort.sortColumn].toString().trim();
                if (typeof lhsValue === 'string' && lhsValue.match(/(\d+)(-|\/)(\d+)(?:-|\/)(?:(\d+)\s+(\d+):(\d+)(?::(\d+))?(?:\.(\d+))?)?/)) {
                    lhsValue = moment(lhsValue, 'DD/MM/YYYY')
                    rhsValue = moment(rhsValue, 'DD/MM/YYYY')
                }
                if (lhsValue === null || lhsValue === undefined || lhsValue === '') {
                    return -1;
                } else if (rhsValue === null || rhsValue === undefined || rhsValue === '') {
                    return 1;
                } else if (lhsValue === rhsValue) {
                    return 0;
                } else if (lastSort.sortDirection === 'asc') {
                    return lhsValue < rhsValue ? -1 : 1;
                } else {
                    return lhsValue < rhsValue ? 1 : -1;
                }
            });
        } else {
            return filteredList;
        }
    }
}
